<template>
  <div>
    <app-cells>
      <div class="date-picker-wrapper">
        <VueCtkDateTimePicker
          id="date_picker_balance"
          class="custom-date-time-picker custom-date-time-picker--range"
          v-model="filter_dates"
          :custom-shortcuts="custom_shortcuts"
          shortcut="last60Days"
          @is-hidden="onIsHiddenPicker"
          format="YYYY-MM-DD"
          formatted="ll"
          label="Select dates"
          color="#77b017"
          button-color="#77b017"
          overlay
          no-header
          no-label
          locale="en"
          range
          noClearButton
        />
        <div v-if="date_picker_error" class="date-picker-wrapper__error">Choose an end date</div>
      </div>
      <app-select
        @input="fetchItems"
        v-model="country"
        :options="country_options"
        :reduce="item => item.code"
        placeholder="Country"
        class="select--200"
      />
    </app-cells>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <v-client-table
        :data="table.items"
        :columns="table.columns"
        :options="table.options"
        class="table-default"
      >
        <template #h__region><div class="table-default__left">Region</div></template>
        <template #h__pre_confirmed>Pre<br>confirmed</template>
        <template #h__deposit_paid>Deposit<br>paid</template>
        <template #h__full_paid>Full<br>paid</template>
        <template #h__amount>Total<br>sales</template>
        <template #index="{ row, index }">{{ index }}</template>
        <template #region="{ row }"><div class="table-default__left">{{ row[0] }}</div></template>
        <template #count="{ row }">{{ row[1].count }}</template>
        <template #lead="{ row }">{{ row[1].lead }}</template>
        <template #negotiation="{ row }">{{ row[1].negotiation }}</template>
        <template #nurture="{ row }">{{ row[1].nurture }}</template>
        <template #postponed="{ row }">{{ row[1].postponed }}</template>
        <template #no_response="{ row }">{{ row[1].no_response }}</template>
        <template #lost="{ row }">{{ row[1].lost }}</template>
        <template #refused="{ row }">{{ row[1].refused }}</template>
        <template #pre_confirmed="{ row }">{{ row[1].pre_confirmed }}</template>
        <template #deposit_paid="{ row }">{{ row[1].deposit_paid }}</template>
        <template #full_paid="{ row }">{{ row[1].full_paid }}</template>
        <template #confirmed="{ row }">{{ row[1].confirmed }}</template>
        <template #completed="{ row }">{{ row[1].completed }}</template>
        <template #conversion="{ row }">{{ row[1].conversion }}%</template>
        <template #amount="{ row }">{{ row[1].amount.toLocaleString() }}$</template>
        <template #commission="{ row }">{{ row[1].commission.toLocaleString() }}$</template>
      </v-client-table>
    </template>
  </div>
</template>

<script>
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import { getCountries, getLeadsAnalyticsRequestsRegions } from '@/http'

export default {
  name: 'CRMAnalyticsRegions',
  components: { VueCtkDateTimePicker },
  data() {
    return {
      is_loaded: false,
      filter_dates: null,
      date_picker_error: false,
      custom_shortcuts: [
        { key: 'last7Days', label: 'Last 7 days', value: 7 },
        { key: 'last30Days', label: 'Last 30 days', value: 30 },
        { key: 'last60Days', label: 'Last 60 days', value: 60 },
        { key: 'last90Days', label: 'Last 90 days', value: 90 },
        { key: 'last180Days', label: 'Last 180 days', value: 180 },
        { key: 'thisYear', label: 'This year', value: 'year' },
        { key: 'lastYear', label: 'Last year', value: '-year' },
      ],
      table: {
        items: [],
        columns: [
          'index',
          'region',
          'count',
          'lead',
          'negotiation',
          'nurture',
          'no_response',
          'lost',
          'refused',
          'pre_confirmed',
          'postponed',
          'deposit_paid',
          'full_paid',
          'completed',
          'conversion',
          'confirmed',
          'amount',
          'commission'
        ],
        options: {
          headings: {
            'index': '#',
            'region': 'Region',
            'count': 'Count',
            'lead': 'Lead',
            'negotiation': 'Negotiation ',
            'nurture': 'Nurture',
            'postponed': 'Postponed',
            'no_response': 'NR',
            'lost': 'Lost',
            'refused': 'Refused',
            'pre_confirmed': 'Pre confirmed',
            'deposit_paid': 'Deposit paid',
            'full_paid': 'Full paid',
            'completed': 'Completed',
            'conversion': 'Conversion',
            'confirmed': 'Confirmed',
            'amount': 'Total sales',
            'commission': 'Commission',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 100000,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      country_options: [],
      country: null,
    }
  },
  created() {
    setTimeout(() => {
      this.$nextTick(() => {
        this.fetchItems()
      })
    }, 0)
    getCountries().then(response => { this.country_options = response.data })
  },
  methods: {
    fetchItems() {
      getLeadsAnalyticsRequestsRegions({from_date: this.filter_dates.start, to_date: this.filter_dates.end, country: this.country})
        .then(response => {
          this.table.items = Object.entries(response.data.instances)
          this.is_loaded = true
        })
    },
    onIsHiddenPicker() {
      this.table_preloader = true
      if (this.filter_dates?.start && this.filter_dates?.end) {
        this.date_picker_error = false
        this.fetchItems()
      } else this.date_picker_error = true
    },
  }
}
</script>
